import { setupForDark } from '@theme';
import classNames from 'classnames';

function TextButton({
  text,
  icon,
  disabled,
  onClick,
  className = ''
}: {
  text: string;
  icon: React.ReactNode;
  disabled?: boolean;
  onClick: () => void;
  className?: string;
}) {
  return (
    <div
      className={classNames(
        'flex flex-row gap-xs items-center justify-start w-fit p-xs',
        'P3R',
        disabled
          ? setupForDark('text-tertiary')
          : setupForDark('text-primary hover:bg-secondary rounded-xs'),
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        className
      )}
      onClick={onClick}
    >
      {!disabled && <div className='flex-shrink-0'>{icon}</div>}
      <div>{text}</div>
    </div>
  );
}

export default TextButton;
